import { render } from "./SectionPersonal.vue?vue&type=template&id=2393064e"
import script from "./SectionPersonal.vue?vue&type=script&lang=js"
export * from "./SectionPersonal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__